export const CONNECT_TYPES = [
 'telegram',
 'viber',
 'email',
] as const;
